import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from './Box';
import type { BorderProps } from './constants';
import { BORDER } from './constants';
import theme from './theme';

type Props = BorderProps;

const BorderBox = styled(Box)<Props>(BORDER);

BorderBox.defaultProps = {
  theme,
  borderWidth: 1,
  borderColor: 'gray.light',
  borderRadius: 1,
  borderStyle: 'solid',
};

BorderBox.propTypes = {
  ...Box.propTypes,
  ...BORDER.propTypes,
  theme: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

BorderBox.displayName = 'BorderBox';

export { BorderBox };
